<template>
  <page status="waiting_approval" :title="i18n('Cadastros aguardando aprovação')" :description="i18n('cadastros aguardando aprovação')" />
</template>

<script>
import CustomersList from "./CustomersList"
export default {
  name: 'CustomersListPending',
  components: { 'page': CustomersList },
  data() {
    return {}
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/CustomersListPending.vue